<template>
  <BlockContainer :has-hover="hasCPIAdjustment" :class="rootClasses" data-cy="cpi-adjustment-card">
    <div class="d-flex align-items-center mb-4">
      <i class="h4" :class="iconClasses" />
      <h5 class="ml-4">Automatisk indeksregulering</h5>
    </div>

    <div class="d-flex align-items-center">
      <div>
        <div v-if="isDisabled">
          <p data-cy="cpi-adjustment-disabled">
            Unngå tap av leieinntekter! Med Premium-abonnement får du automatisk indeksregulering av husleien.
          </p>
          <UpdateSubscriptionButton
            :landlord-id="landlordId"
            :tenancy-id="tenancyId"
            buttonCTA="Oppgrader til Premium"
            origin="dashboard_tenancyview_overview_rentregulation"
          />
        </div>

        <div v-else-if="hasCPIAdjustment" class="CPIAdjustmentContent">
          <div>
            <span>Status:</span>
            <hl-Tag class="ml-2" variant="border" variation="primary"> Aktivert </hl-Tag>
          </div>

          <div>
            <span>Neste regulering:</span>
            <span class="ml-2" data-cy="next-cpi-adjustment">
              {{ nextCPIAdjustment }}
            </span>
          </div>
        </div>

        <template v-else>
          <p>Automatisk indeksregulering er ikke aktivert på dette leieforholdet.</p>

          <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-primary mt-4" @click="$emit('click')">Aktiver nå</button>
          </div>
        </template>
      </div>
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
import UpdateSubscriptionButton from '@/components/upsale/UpdateSubscriptionButton.vue';
import Tag from '@modules/husleie-framework/src/components/forms/inputs/tags/Tag.vue';
import { LandlordApi } from '@modules/husleieapi2';

export default {
  data() {
    return {
      availableSubscriptions: [],
    };
  },
  components: {
    BlockContainer,
    UpdateSubscriptionButton,
    'hl-Tag': Tag,
  },
  props: {
    landlordId: [String, Number],
    tenancyId: [String, Number],
    isDisabled: {
      type: Boolean,
      default: false,
    },
    hasCPIAdjustment: {
      type: Boolean,
      default: false,
    },
    nextCPIAdjustment: {
      type: String,
      default: undefined,
    },
    isFullHeight: {
      type: Boolean,
      default: false,
    },
  },
  SETTINGS_LINK: {
    name: 'tenancy_settings',
    query: { highlight: 'kpi' },
  },
  computed: {
    premiumPrice() {
      const premium = this.availableSubscriptions.find(sub => sub.name === 'Premium');

      return premium ? premium.price : '';
    },
    rootClasses() {
      return [
        'tenancyCardCPIAdjustment',
        'p-4',
        {
          isFullHeight: this.isFullHeight,
        },
      ];
    },
    iconClasses() {
      const active = ['budicon-check-done'];
      const inactive = ['budicon-cross-sign'];

      return this.hasCPIAdjustment ? active : inactive;
    },
  },
  async created() {
    const api = new LandlordApi();
    this.availableSubscriptions = await api.getLandlordAvailableSubscriptions(this.landlordId);
  },
};
</script>

<style>
.tenancyCardCPIAdjustment {
  @apply p-4;
}

.tenancyCardCPIAdjustment.isFullHeight {
  @apply h-full;
}
</style>

<style lang="scss" scoped>
.bg-op-secondary {
  background: rgba($secondary, 0.2);
}

.bg-op-success {
  background: rgba($success, 0.2);
}

.bg-op-primary {
  background: rgba($primary, 0.2);
}

.bg-op-info {
  background: rgba($info, 0.2);
}

.CPIAdjustmentContent {
  display: flex;
  flex-direction: column;
  row-gap: 0.3rem;
}

.CPIAdjustmentContent div {
  display: grid;
  grid-template-columns: 8rem auto;
}
</style>
